<template>
<div class="chapter">
<div class="inner_page">
<p class="copyv"><a id="pl-2"></a>Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Acquisitions Editor: Roxane Cerda</p>
<p class="copy">Managing Editor: Liz Aneloski</p>
<p class="copy">Editor: Katie Van Amburg</p>
<p class="copy">Technical Editor: Debbie Rodgers</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Production Editor: Jennifer Warren</p>
<p class="copy">Illustrator: Kirstie L. Pettersen</p>
<p class="copy">Photo Assistant: Lauren Herberg</p>
<p class="copy">Instructional photography by Carrie J. Buck; subjects photography by Estefany Gonzalez of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copyt">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0003_copyright-title.vue?b7069bd6